const themesulut = {
    primary: '#03045c',
    secondary: '#990e10',
    btnprimary: '#03045c',
};
export default themesulut